import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { SettingsTabs } from "@/routes/settings/SettingsTabs";
import {
  getCurrentSettingsTab,
  getSettingsTabs,
  SETTINGS_TAB_PATHS,
} from "./settingsTabsShared";

export function SettingsAccountRoute() {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Settings", path: "/settings" },
      { label: "Account", path: "/settings/account" },
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, []);

  const handleTabChange = (value: string) => {
    const path = SETTINGS_TAB_PATHS[value];
    if (path) navigate(path);
  };

  return (
    <SettingsTabs
      value={getCurrentSettingsTab(location.pathname)}
      tabs={getSettingsTabs()}
      onValueChange={handleTabChange}
    />
  );
}
